import { render, staticRenderFns } from "./ConfirmBuyDialog.vue?vue&type=template&id=a8059ac2&scoped=true"
import script from "./ConfirmBuyDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmBuyDialog.vue?vue&type=script&lang=js"
import style0 from "./ConfirmBuyDialog.vue?vue&type=style&index=0&id=a8059ac2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8059ac2",
  null
  
)

export default component.exports